module.exports = __webpack_public_path__ + "img/close-btn.cee69e5b.svg";